// src/config/moduleList.js
import { SCOPES } from "./permissions";

export const SYSTEM_MODULES = [
  {
    category: "Dashboard & Analytics",
    modules: [
      { label: "View Dashboard", key: SCOPES.VIEW_DASHBOARD },
      { label: "View Reports", key: SCOPES.VIEW_REPORTING },
    ]
  },
  {
    category: "Finance & Accounting",
    modules: [
      { label: "View Financial Dashboard", key: SCOPES.VIEW_FINANCE },
      { label: "Manage Budgets", key: SCOPES.MANAGE_BUDGET },
      { label: "View Accounting", key: SCOPES.VIEW_ACCOUNTING },
      { label: "Manage Invoices (Money In)", key: SCOPES.MANAGE_INVOICES },
      { label: "Manage Bills (Money Out)", key: SCOPES.MANAGE_BILLS },
      { label: "Approve Transactions", key: SCOPES.APPROVE_TRANSACTIONS },
      { label: "View Financial Reports", key: SCOPES.VIEW_REPORTS },
    ]
  },
  {
    category: "CRM (Sales)",
    modules: [
      { label: "View CRM", key: SCOPES.VIEW_CRM },
      { label: "Manage CRM", key: SCOPES.MANAGE_CRM },
      { label: "Delete CRM Data", key: SCOPES.DELETE_CRM }
    ]
  },
  {
    category: "Project Management",
    modules: [
      { label: "View Projects", key: SCOPES.VIEW_PROJECTS },
      { label: "Manage Projects", key: SCOPES.MANAGE_PROJECTS },
      { label: "View Tasks", key: SCOPES.VIEW_TASKS },
      { label: "Manage Tasks", key: SCOPES.MANAGE_TASKS }
    ]
  },
  {
    category: "Workforce & HR",
    modules: [
      { label: "View Workforce", key: SCOPES.VIEW_WORKFORCE },
      { label: "Manage Workforce", key: SCOPES.MANAGE_WORKFORCE },
      { label: "Delete Workforce", key: SCOPES.DELETE_WORKFORCE },
      { label: "View All Attendance", key: SCOPES.VIEW_ATTENDANCE },
      { label: "Assign & Manage Shifts", key: SCOPES.MANAGE_SHIFTS },
      { label: "Approve / Reject Leaves", key: SCOPES.MANAGE_LEAVES }
    ]
  },
  {
    category: "Asset Management",
    modules: [
      { label: "View Assets", key: SCOPES.VIEW_ASSETS },
      { label: "Manage Assets", key: SCOPES.MANAGE_ASSETS },
      { label: "Delete Assets", key: SCOPES.DELETE_ASSETS }
    ]
  },
  {
    category: "Materials & Inventory",
    modules: [
      { label: "View Purchase Orders", key: SCOPES.VIEW_PURCHASE },
      { label: "View Inventory", key: SCOPES.VIEW_INVENTORY },
      { label: "Picking Operations", key: SCOPES.VIEW_PICKING },
      { label: "Scrap Management", key: SCOPES.VIEW_SCRAP },
      { label: "Warehouse Management", key: SCOPES.VIEW_WAREHOUSE },
    ]
  },
  {
    category: "Stakeholders (HR & Vendors)",
    modules: [
      { label: "View Vendors", key: SCOPES.VIEW_VENDORS },
      { label: "View Employees", key: SCOPES.VIEW_EMPLOYEES },
    ]
  },
  {
    category: "Compliance & Docs",
    modules: [
      { label: "View Compliance", key: SCOPES.VIEW_COMPLIANCE },
      { label: "View Documents", key: SCOPES.VIEW_DOCUMENTS },
    ]
  },
  {
    category: "System Administration",
    modules: [
      { label: "View Users", key: SCOPES.VIEW_USERS },
      { label: "Create User", key: SCOPES.CREATE_USER },
      { label: "View Roles", key: SCOPES.VIEW_ROLES },
      { label: "Manage Roles", key: SCOPES.MANAGE_ROLES },
    ]
  }
];